const DocumentsProcess = () => (
    <div className="page-content">
        <h1>Documents entrants</h1>
        <p>Bienvenue sur la page Documents entrants.</p>
    </div>
);

export default DocumentsProcess;